import { Listing, Review, AnonymousThought } from '../types'

export const featuredGoods: Listing[] = [
  {
    id: 'g1',
    type: 'good',
    title: 'Handcrafted Necklace',
    description: 'Beautiful handmade jewelry with local materials',
    image:
      'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=400&h=300&fit=crop',
    price: 2500,
    location: 'Nakuru',
    views: 145,
    createdAt: '2024-01-15',
    userId: 'u1',
    userName: 'Sarah M.',
    userAvatar:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop',
  },
  {
    id: 'g2',
    type: 'good',
    title: 'Canon DSLR Camera',
    description: 'Professional photography equipment for sale',
    image:
      'https://images.unsplash.com/photo-1516035069371-29a1b244cc32?w=400&h=300&fit=crop',
    price: 45000,
    location: 'Nakuru',
    views: 196,
    createdAt: '2024-01-14',
    userId: 'u2',
    userName: 'James K.',
    userAvatar:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop',
  },
  {
    id: 'g3',
    type: 'good',
    title: 'Custom Sneakers',
    description: 'Hand-painted custom sneakers, unique designs',
    image:
      'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&h=300&fit=crop',
    price: 8500,
    location: 'Nakuru',
    views: 1516,
    createdAt: '2024-01-13',
    userId: 'u3',
    userName: 'Mike O.',
    userAvatar:
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop',
  },
]

export const featuredServices: Listing[] = [
  {
    id: 's1',
    type: 'service',
    title: 'Graphic Design',
    description: 'Professional graphic design services for businesses',
    image:
      'https://images.unsplash.com/photo-1626785774573-4b799315345d?w=400&h=300&fit=crop',
    location: 'Nakuru',
    views: 156,
    createdAt: '2024-01-15',
    userId: 'u4',
    userName: 'Lisa W.',
    userAvatar:
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop',
  },
  {
    id: 's2',
    type: 'service',
    title: 'Photography Services',
    description: 'Event and portrait photography',
    image:
      'https://images.unsplash.com/photo-1554048612-b6a482bc67e5?w=400&h=300&fit=crop',
    location: 'Nakuru',
    views: 156,
    createdAt: '2024-01-14',
    userId: 'u5',
    userName: 'Peter N.',
    userAvatar:
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop',
  },
  {
    id: 's3',
    type: 'service',
    title: 'Makeup Artist',
    description: 'Professional makeup for events and photoshoots',
    image:
      'https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=400&h=300&fit=crop',
    location: 'Nakuru',
    views: 1890,
    createdAt: '2024-01-13',
    userId: 'u6',
    userName: 'Grace A.',
    userAvatar:
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop',
  },
]

export const upcomingEvents: Listing[] = [
  {
    id: 'e1',
    type: 'event',
    title: 'Art Expo',
    description: 'Annual art exhibition featuring local artists',
    image:
      'https://images.unsplash.com/photo-1531058020387-3be344556be6?w=400&h=300&fit=crop',
    location: 'Nakuru',
    views: 98,
    createdAt: '2024-01-15',
    userId: 'u7',
    userName: 'Art Gallery',
    userAvatar:
      'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=100&h=100&fit=crop',
    eventDate: 'Dec 20, 2024',
    eventTime: '2:00 PM',
  },
  {
    id: 'e2',
    type: 'event',
    title: 'Live Music Night',
    description: 'Live performances by local musicians',
    image:
      'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&h=300&fit=crop',
    location: 'Nakuru',
    views: 156,
    createdAt: '2024-01-14',
    userId: 'u8',
    userName: 'Music Hub',
    userAvatar:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop',
    eventDate: 'Dec 22, 2024',
    eventTime: '7:00 PM',
  },
  {
    id: 'e3',
    type: 'event',
    title: 'Fashion Showcase',
    description: 'Showcasing local fashion designers',
    image:
      'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop',
    location: 'Nakuru',
    views: 956,
    createdAt: '2024-01-13',
    userId: 'u9',
    userName: 'Fashion Week',
    userAvatar:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop',
    eventDate: 'Dec 25, 2024',
    eventTime: '4:00 PM',
  },
]

export const latestNews: Listing[] = [
  {
    id: 'n1',
    type: 'news',
    title: 'Nakuru Art Fair Recap',
    description: 'Highlights from the annual Nakuru Art Fair',
    image:
      'https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=400&h=300&fit=crop',
    location: 'Nakuru',
    views: 956,
    createdAt: 'May 14, 2024',
    userId: 'u10',
    userName: 'News Team',
    userAvatar:
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop',
  },
  {
    id: 'n2',
    type: 'news',
    title: 'Tips for Creative Entrepreneurs',
    description: 'Essential tips for starting your creative business',
    image:
      'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop',
    location: 'Nakuru',
    views: 936,
    createdAt: 'May 14, 2024',
    userId: 'u11',
    userName: 'Business Tips',
    userAvatar:
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop',
  },
  {
    id: 'n3',
    type: 'news',
    title: 'New Photography Trends',
    description: 'Latest trends in photography for 2024',
    image:
      'https://images.unsplash.com/photo-1542038784456-1ea8e935640e?w=400&h=300&fit=crop',
    location: 'Nakuru',
    views: 956,
    createdAt: 'May 14, 2024',
    userId: 'u12',
    userName: 'Photo News',
    userAvatar:
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop',
  },
]

export const anonymousThoughts: AnonymousThought[] = [
  { id: 't1', content: 'Just finished a huge project! So relieved?' },
  {
    id: 't2',
    content: 'Is it just me or is inspiration harder to find lately?',
  },
  { id: 't3', content: 'Why do deadlines always sneak up on me?' },
]

export const clientReviews: Review[] = [
  {
    id: 'r1',
    userName: 'Jane M.',
    userAvatar:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop',
    rating: 5,
    comment: 'Amazing platform! Found great clients.',
  },
  {
    id: 'r2',
    userName: 'David K.',
    userAvatar:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop',
    rating: 5,
    comment: 'Fantastic services. Highly recommended!',
  },
  {
    id: 'r3',
    userName: 'Sara T.',
    userAvatar:
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop',
    rating: 5,
    comment: 'Very professional. Will use again!',
  },
]

export const allGoods: Listing[] = [
  ...featuredGoods,
  {
    id: 'g4',
    type: 'good',
    title: 'Handwoven Basket',
    description: 'Traditional Kenyan handwoven basket',
    image:
      'https://images.unsplash.com/photo-1590736969955-71cc94901144?w=400&h=300&fit=crop',
    price: 1500,
    location: 'Nakuru',
    views: 89,
    createdAt: '2024-01-12',
    userId: 'u13',
    userName: 'Mary J.',
    userAvatar:
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop',
  },
  {
    id: 'g5',
    type: 'good',
    title: 'Leather Wallet',
    description: 'Genuine leather handcrafted wallet',
    image:
      'https://images.unsplash.com/photo-1627123424574-724758594e93?w=400&h=300&fit=crop',
    price: 3500,
    location: 'Nakuru',
    views: 234,
    createdAt: '2024-01-11',
    userId: 'u14',
    userName: 'John D.',
    userAvatar:
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop',
  },
  {
    id: 'g6',
    type: 'good',
    title: 'Beaded Jewelry Set',
    description: 'Colorful beaded necklace and earrings',
    image:
      'https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=400&h=300&fit=crop',
    price: 2000,
    location: 'Nakuru',
    views: 178,
    createdAt: '2024-01-10',
    userId: 'u15',
    userName: 'Faith N.',
    userAvatar:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop',
  },
]

export const allServices: Listing[] = [
  ...featuredServices,
  {
    id: 's4',
    type: 'service',
    title: 'Web Development',
    description: 'Custom website development services',
    image:
      'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=400&h=300&fit=crop',
    location: 'Nakuru',
    views: 312,
    createdAt: '2024-01-12',
    userId: 'u16',
    userName: 'Tech Pro',
    userAvatar:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop',
  },
  {
    id: 's5',
    type: 'service',
    title: 'Video Editing',
    description: 'Professional video editing and production',
    image:
      'https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?w=400&h=300&fit=crop',
    location: 'Nakuru',
    views: 267,
    createdAt: '2024-01-11',
    userId: 'u17',
    userName: 'Video Master',
    userAvatar:
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop',
  },
  {
    id: 's6',
    type: 'service',
    title: 'Interior Design',
    description: 'Home and office interior design services',
    image:
      'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=400&h=300&fit=crop',
    location: 'Nakuru',
    views: 189,
    createdAt: '2024-01-10',
    userId: 'u18',
    userName: 'Design Studio',
    userAvatar:
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop',
  },
]

export const allEvents: Listing[] = [
  ...upcomingEvents,
  {
    id: 'e4',
    type: 'event',
    title: 'Photography Workshop',
    description: 'Learn photography basics from professionals',
    image:
      'https://images.unsplash.com/photo-1516035069371-29a1b244cc32?w=400&h=300&fit=crop',
    location: 'Nakuru',
    views: 145,
    createdAt: '2024-01-12',
    userId: 'u19',
    userName: 'Photo Academy',
    userAvatar:
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop',
    eventDate: 'Dec 28, 2024',
    eventTime: '10:00 AM',
  },
  {
    id: 'e5',
    type: 'event',
    title: 'Craft Market',
    description: 'Local artisans showcase their crafts',
    image:
      'https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a?w=400&h=300&fit=crop',
    location: 'Nakuru',
    views: 234,
    createdAt: '2024-01-11',
    userId: 'u20',
    userName: 'Craft Guild',
    userAvatar:
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop',
    eventDate: 'Dec 30, 2024',
    eventTime: '9:00 AM',
  },
]

export const allNews: Listing[] = [
  ...latestNews,
  {
    id: 'n4',
    type: 'news',
    title: 'Local Artists Win Awards',
    description: 'Nakuru artists recognized at national competition',
    image:
      'https://images.unsplash.com/photo-1578926288207-a90a5366759d?w=400&h=300&fit=crop',
    location: 'Nakuru',
    views: 678,
    createdAt: 'May 10, 2024',
    userId: 'u21',
    userName: 'Arts News',
    userAvatar:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop',
  },
  {
    id: 'n5',
    type: 'news',
    title: 'New Creative Hub Opens',
    description: 'A new space for creatives to collaborate',
    image:
      'https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=300&fit=crop',
    location: 'Nakuru',
    views: 543,
    createdAt: 'May 8, 2024',
    userId: 'u22',
    userName: 'Community News',
    userAvatar:
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop',
  },
]
